"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_reconciler_1 = __importDefault(require("react-reconciler"));
var scheduler_1 = require("scheduler");
var DrawNode_1 = __importDefault(require("./nodes/DrawNode"));
var Node_1 = __importDefault(require("./nodes/Node"));
exports.default = react_reconciler_1.default({
    supportsMutation: true,
    isPrimaryRenderer: false,
    supportsPersistence: false,
    supportsHydration: false,
    now: scheduler_1.unstable_now,
    //  scheduleDeferredCallback: window.requestIdleCallback,
    //this is not implmented in the type def but required
    //@ts-ignore
    clearContainer: function (rootNode) {
        rootNode.destroy();
    },
    commitMount: function (instance, type, newProps, internalInstanceHandle) {
    },
    /**
     * Create component instance
     */
    createInstance: function (type, props) {
        if (type === 'ReglDraw') {
            return new DrawNode_1.default(props);
        }
        return new Node_1.default(props);
    },
    appendChild: function (parentInstance, child) {
        parentInstance.appendChild(child);
    },
    appendChildToContainer: function (container, child) {
        container.appendChild(child);
    },
    insertBefore: function (parentInstance, child, beforeChild) {
        parentInstance.insertBefore(child, beforeChild);
    },
    removeChild: function (parentInstance, child) {
        parentInstance.removeChild(child);
    },
    removeChildFromContainer: function (container, child) {
        container.removeChild(child);
    },
    finalizeInitialChildren: function () {
        return true;
    },
    prepareUpdate: function (instance, type, oldProps, newProps) {
        if (instance.executionProps !== newProps.executionProps) {
            return newProps.executionProps;
        }
        return null;
    },
    commitUpdate: function (instance, updatePayload, type) {
        instance.executionProps = updatePayload;
    },
    /**
     * Append the children. If children are wrapped inside a parent container, then push all the children
     * inside it else we create a property called `document` on a parent node and append all the childrens
     * to it and render them with `property_name.render()`.
     */
    appendInitialChild: function (parentInstance, child) {
        parentInstance.appendChild(child);
    },
    /**
     * Keeps track of the current location in tree
     */
    getRootHostContext: function (rootHostContext) {
        return rootHostContext;
    },
    getChildHostContext: function (parentHostContext) {
        return parentHostContext;
    },
    getPublicInstance: function (inst) {
        return inst;
    },
    cancelDeferredCallback: function (callbackID) {
        return null;
    },
    /**
     * Disable callbacks during DOM manipulation
     */
    prepareForCommit: function () {
        // noop
        return null;
    },
    resetAfterCommit: function () {
        // noop
    },
    createTextInstance: function () {
        // Not sure what to do with text nodes it expects a node return
        throw new Error("Text nodes not supported as ReactRegl children");
    },
    shouldSetTextContent: function () {
        return false;
    },
    shouldDeprioritizeSubtree: function () {
        return true;
    }
});
